// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1Pqql","image":"styles_image__1GgRw","title":"styles_title__1EMC6","message":"styles_message__3g8Y1"};